// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1H2ps","empty":"ModalGraph_empty__1AWOh"};